(function () {
    'use strict';
    angular.module('components.dialog', [
        'ui.bootstrap',
        'toastr'
    ]);
})();